import { API } from 'aws-amplify'
import APIRoutes from '../../api/routes'

export const fetchLegalInfo = (dispatch, businessId) => {
    API.get('DEFAULT_ENDPOINT', APIRoutes.legalInfo, {
        queryStringParameters: { businessId }
    }).then(res => {
        dispatch({
            type: 'UPDATELEGALINFO',
            payload: res.details,
        })
    })
}

export const saveLegalInfo = (dispatch, { businessId, legalInfo }, callBack) => {
    API.put('DEFAULT_ENDPOINT', APIRoutes.legalInfo, {
        body: { businessId, legalInfo },
    }).then(res => {
        fetchLegalInfo(dispatch, businessId)
        callBack && callBack({
            isOpen: true,
            type: 'success',
            message: 'Successfully updated Legal information'
        })
    })
        .catch(err => callBack && callBack({
            isOpen: true,
            type: 'error',
            message: 'Something went wrong. Please try after some time.'
        }))
}

export const fetchContactInfo = (dispatch, businessId) => {
    API.get('DEFAULT_ENDPOINT', APIRoutes.contactInfo, {
        queryStringParameters: { businessId }
    }).then(res => {
        dispatch({
            type: 'UPDATECONTACTINFO',
            payload: res.details,
        })
    })
}


export const saveContactInfo = (dispatch, { businessId, contactInfo, primaryContactInfo,
    addressContactInfo }, callBack) => {
    API.put('DEFAULT_ENDPOINT', APIRoutes.contactInfo, {
        body: { businessId, primaryContactInfo, contactInfo, addressContactInfo },
    }).then(res => {
        fetchContactInfo(dispatch, businessId)
        fetchStateContactInfo(dispatch, businessId)
        callBack && callBack({
            isOpen: true,
            type: 'success',
            message: 'Successfully updated Contact information'
        })
    })
        .catch(err => callBack && callBack({
            isOpen: true,
            type: 'error',
            message: 'Something went wrong. Please try after some time.'
        }))
}

export const fetchDescriptiveInfo = (dispatch, businessId) => {
    API.get('DEFAULT_ENDPOINT', APIRoutes.descriptiveInfo, {
        queryStringParameters: { businessId }
    }).then(res => {
        dispatch({
            type: 'UPDATEDESCRIPTIVEINFO',
            payload: res.details,
        })
    })
}

export const saveDescriptiveInfo = (dispatch, { businessId, descriptiveInfo, descriptiveInfoCheckList,
    descriptiveInfoSocialMedia, descriptiveInfoLogo, descriptiveInfoDescription }, callBack) => {
    API.put('DEFAULT_ENDPOINT', APIRoutes.descriptiveInfo, {
        body: {
            businessId, descriptiveInfoCheckList, descriptiveInfo, descriptiveInfoSocialMedia,
            descriptiveInfoDescription, descriptiveInfoLogo
        },
    }).then(res => {
        fetchDescriptiveInfo(dispatch, businessId)
        callBack && callBack({
            isOpen: true,
            type: 'success',
            message: 'Successfully updated Descriptive information'
        })
    })
        .catch(err => callBack && callBack({
            isOpen: true,
            type: 'error',
            message: 'Something went wrong. Please try after some time.'
        }))
}

export const fetchStateContactInfo = (dispatch, mkzBusinessId) => {
    API.get('DEFAULT_ENDPOINT', APIRoutes.stateContactInfo, {
        queryStringParameters: { mkzBusinessId }
    }).then(res => {
        dispatch({
            type: 'UPDATESTATECONTACTINFO',
            payload: res.details,
        })
    })
    // return res
}